module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-3.6b0fb6fd.mp3";